import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { debounce } from "lodash";
import { twMerge } from "tailwind-merge";

import { dateOf } from "./format";

/** Not null or undefined */
export function hasValue(i: any) {
	return i !== undefined && i !== null;
}
export function noValue(i: any) {
	return !hasValue(i) || i === "";
}
export function notEmpty(i: any) {
	return hasValue(i) && i !== "";
}

export function bidirectionalStringContains(string1: string, string2: string, caseInsensitive = true) {
	if (caseInsensitive) {
		string1 = string1.toLowerCase();
		string2 = string2.toLowerCase();
	}
	return string1.includes(string2) || string2.includes(string1);
}

/** Concatenates css styles */
export function styles(...styles: string[]) {
	return styles.filter((s) => s).join(" ");
}

/** Get URL param value from name of url param */
export function getUrlParameter(name: string) {
	name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	const results = regex.exec(window.location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/** Creates deep copy of object */
export function clone<T>(obj: T) {
	return obj && (JSON.parse(JSON.stringify(obj)) as T);
}

export function today() {
	return new Date(dateOf(new Date()));
}

/** Generates guid */
export function guid() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function enumToString(e: string) {
	return e
		.replace(/([A-Z])/g, (match) => ` ${match}`)
		.replace(/^./, (match) => match.toUpperCase())
		.trim();
}

export function delay(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export interface Surefox {
	closeCurrentTab: Function;
	closeAllTabs: Function;
	back: Function;
	forward: Function;
	home: Function;
	refresh: Function;
	stop: Function;
	exit: Function;
	isAppInstalled: (appId: string) => boolean;
	killApp: (appId: string) => boolean;
	load: (url: string) => void;
	openInNewTab: (url: string) => void;
	launch: (app: string, restart: boolean) => void;
}
interface Window {
	surefox: Surefox;
}

export function getSurefox() {
	return (window as any as Window).surefox as Surefox;
}

/**
 * Below code borrowed from AVL to try to prevent scroll to refresh
 */
interface Window {
	opera: any;
	MSStream: any;
}

class DeviceDefinition {
	constructor() {
		const w = window as any;
		const userAgent = navigator.userAgent || navigator.vendor || w.opera;
		this.windows = /windows phone/i.test(userAgent);
		this.android = /android/i.test(userAgent);
		this.ios = /iPad|iPhone|iPod/.test(userAgent) && !w.MSStream;
	}
	windows: boolean;
	android: boolean;
	ios: boolean;
}

const Device = new DeviceDefinition();

export function preventBounce() {
	if (Device.ios) {
		//need to add event after body created
		document.body.addEventListener(
			"touchmove",
			function (e: TouchEvent) {
				e.preventDefault();
				//magically helps click events to be more precise
				if (e.target) {
					debounce(function () {
						(e.target as HTMLElement).click();
					}, 300)();
				}
			},
			false,
		);
	}
}

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
